var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text",on:{"mouseenter":_vm.mouseEnter,"mouseleave":_vm.mouseLeave}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    ")])
}
var staticRenderFns = []

export { render, staticRenderFns }